import React  from 'react';
import Moment from 'react-moment';

export default class Moment_time extends React.Component {
    render(props) {
        return (
            <Moment toNow ago>props.mica_custom_part_time_timestamp</Moment>
        );
    }
}